export const menuApi = {
    heading:[
        {
            head:"Menu ID"
        },
        {
            head:"Menu Name"
        },
        {
            head:"URL"
        },
        {
            head:"Sequence"
        },
        {
            head:"Parent Menu"
        },
        {
            head:"Active From"
        },
        {
            head:"Active To"
        },
        {
            head:"Action"
        }
    ],
    data:[
        {
            menuid:1,            
            menuname:"menu name", 
            url:"www.fb.com", 
            sequence:"abc",
            parentmenu:"Home1",            
            activefrom:"2023-01-15",
            activeto:"2023-05-14",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            menuid:2,
            menuname:"Name here", 
            url:"www.twitter.com", 
            sequence:"def",
            parentmenu:"Home2",            
            activefrom:"2023-02-16",
            activeto:"2023-06-18",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
        
        {

        },
       
    ]
}